import { TextField } from '@mui/material';
import PropTypes from 'prop-types';
import { forwardRef } from 'react';
import { Controller } from 'react-hook-form';
import { NumericFormat } from 'react-number-format';

const FormInputScore = forwardRef(({ name, label, control, errors, disabled, placeholder, ...props }, ref) => {
    return (
        <Controller
            control={control}
            name={name}
            render={({ field }) => (
                <NumericFormat
                    {...field}
                    ref={ref}
                    allowNegative={false}
                    decimalScale={0}
                    isAllowed={(values) => {
                        if (!values.value) return true
                        const { floatValue } = values
                        return floatValue <= 1000
                    }}
                    customInput={TextField}
                    placeholder={placeholder || label}
                    label={label}
                    error={!!errors}
                    helperText={errors?.message}
                    disabled={disabled}
                    onFocus={(event) => event.target.select()}
                    {...props}
                />
            )}
        />
    )
})

FormInputScore.propTypes = {
    name: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    control: PropTypes.object,
    errors: PropTypes.object,
    disabled: PropTypes.bool,
    placeholder: PropTypes.string
}

FormInputScore.displayName = 'FormInputScore'

export default FormInputScore